import React from 'react';
import api from '../../services/api';

export default function PollMessage({ message, currentLogin }) {
    const { poll } = message;
    if (!poll) return null;

    const totalVotes = poll.options.reduce((acc, o) => acc + (o.votes?.length || 0), 0);
    const myVotes = new Set();
    poll.options.forEach(o => {
        if ((o.votes || []).some(v => v.userLogin === currentLogin)) myVotes.add(o.id);
    });

    const handleVote = async (optionId) => {
        if (poll.closed) return;
        try { await api.chat.pollVote(message._id, optionId); } catch (_) {}
    };

    return (
        <div>
            <div className="pchat-poll-question">📊 {poll.question}</div>
            {poll.options.map(opt => {
                const count = opt.votes?.length || 0;
                const pct = totalVotes ? Math.round((count / totalVotes) * 100) : 0;
                return (
                    <div
                        key={opt.id}
                        className={`pchat-poll-option ${myVotes.has(opt.id) ? 'voted' : ''}`}
                        onClick={() => handleVote(opt.id)}
                    >
                        <div className="pchat-poll-fill" style={{ width: `${pct}%` }} />
                        <div className="pchat-poll-label">
                            <span>{myVotes.has(opt.id) ? '✓ ' : ''}{opt.text}</span>
                            <span>{count} ({pct}%)</span>
                        </div>
                    </div>
                );
            })}
            <div className="pchat-poll-summary">
                Всего голосов: {totalVotes}{poll.closed ? ' • опрос закрыт' : ''}
            </div>
        </div>
    );
}
